import type { MemberResponsibleGamingTimeoutColumns } from '@library/types/memberResponsibleGaming';
import type { TableColumn } from '@library/types/utils';

export const memberRGTimeoutTableHeaders: Array<
  TableColumn<MemberResponsibleGamingTimeoutColumns>
> = [
  {
    column: 'type',
    essential: true,
    label: 'Type',
    sortEnabled: false,
    width: 'basis-96'
  },
  {
    column: 'updateAt',
    essential: true,
    label: 'Updated At',
    sortEnabled: false,
    width: 'basis-96'
  },
  {
    column: 'ends',
    essential: true,
    label: 'Ends',
    sortEnabled: false,
    width: 'basis-96'
  },
  {
    column: 'timeRemaining',
    essential: true,
    label: 'Time remaining',
    sortEnabled: false,
    width: 'basis-96'
  }
];
